import React from "react";

import { DEFAULT_DATA_ATTR_NAME, getAutomationDataAttr } from "../../../utils/automationUtils";

import "./styles.scss";

const Button = (props) => {
  const testId = props[DEFAULT_DATA_ATTR_NAME] || undefined;

  return (
    <button type={props.type} {...props} {...getAutomationDataAttr(testId)}>
      {props.children}
    </button>
  );
};

export default Button;
